import { useMutation } from '@tanstack/react-query';
import { Event } from '../../../types/Event';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { mutationKeys } from '../mutationKeys';

export const updateEvent = async (uuid: string, formData: Event) => {
  const response = await CustomAxios.put(`events/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdateEventFormProps {
  uuid: string;
  onSuccessCallback: () => void;
}
export function useUpdateEvent({ uuid, onSuccessCallback }: UseUpdateEventFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateEvent],
    mutationFn: (formData: Event) => updateEvent(uuid, formData),
    onSuccess: (data: Event) => {
      // fetch the event again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEvents, data.uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const event: Event = err.response.data as Event;
        queryClient.setQueryData([queryKeys.allEvents, event.uuid], event);
      }
    },
  });
}
